import axios, { AxiosResponse } from 'axios'

import { env } from '@js/utils/env'
import gql from '@js/api/utils/gql'
import getStoreName from '@js/api/utils/getStoreName'
import getBearerToken from '@js/api/utils/getBearerToken'
import { cartFragment } from '@js/api/fragments/cartFragment'

import { Cart } from '@js/api/types/cart/Cart'
import { PaymentMethodInput } from '@js/api/types/payment/PaymentMethodInput'

interface SetPaymentMethodOnCartResponse {
  data: {
    setPaymentMethodOnCart: {
      cart: Cart
    } | null
  }
  errors?: [{ message: string }]
}

export const setPaymentMethodOnCartMutation = gql`
  mutation($cartId: String!, $paymentMethod: PaymentMethodInput!) {
    setPaymentMethodOnCart(
      input: {
        cart_id: $cartId,
        payment_method: $paymentMethod
      }
    ) {
      cart {
        ...CartDetails
      }
    }
  }
  ${cartFragment}
`

/**
 * @throws {string}
 *
 * Will throw one error message; Magento only returns one at a time, rather than an array of all errors.
 */
export const setPaymentMethodOnCart = async (
  payload: {
    cartId: string,
    paymentMethod: PaymentMethodInput
}): Promise<Cart | null> => {
  const bearerToken = getBearerToken()

  const { data }: AxiosResponse<SetPaymentMethodOnCartResponse> = await axios({
    method: 'POST',
    url: env.magento.GRAPHQL_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${bearerToken}`,
      Store: getStoreName(),
    },
    data: {
      query: setPaymentMethodOnCartMutation,
      variables: {
        cartId: payload.cartId,
        paymentMethod: payload.paymentMethod,
      },
    },
  })

  if (data.errors) {
    throw data.errors[0].message
  }

  if (data.data.setPaymentMethodOnCart) {
    return data.data.setPaymentMethodOnCart.cart
  }

  return null
}
